import { render, staticRenderFns } from "./vUpsellModal.vue?vue&type=template&id=3827c38d&scoped=true"
import script from "./vUpsellModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vUpsellModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3827c38d",
  null
  
)

export default component.exports